import { render, staticRenderFns } from "./Films.vue?vue&type=template&id=1f0c5150"
import script from "./Films.vue?vue&type=script&lang=ts"
export * from "./Films.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports